




























import BaseComponent from '@/components/base-component.vue';
import ParametersEditModal from '@/components/parameters/edit-modal.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import ParameterModel from '@/models/parameter-model';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
    components:{
        PermissionAuth,
        ParametersEditModal,
    }
})
export default class ParametersFormPasswordType extends BaseComponent{
    @Prop()
    public editItem: any;
    @Prop()
    public modalOpen: boolean;

    public item: ParameterModel = new ParameterModel();

    public onClose(): void {
        this.$emit('close');
    }    
    
    public onEditItemChanges(val: any) {
        this.item = new ParameterModel();

        if (!val) {
            return;
        }

        this.item = new ParameterModel(this.editItem);        
    }

    public beforeMount(): void {
        this.onEditItemChanges(this.editItem);
    }
    
}
